export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_08.cbf7e5ec.jpg";